import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiEndpoints } from "../../helpers/constants";
import Axios, { authHeaders2 } from "../../helpers/axios";
import { handleTokenRefresh } from "./userSlice";

export const reqToUploadMediaFile = createAsyncThunk(
  apiEndpoints.media,
  async ({ data, onSuccess, onFailure }) => {
    const request = {
      method: "POST",
      url: process.env.REACT_APP_MEDIA_URL + apiEndpoints.media,
      data,
      headers: authHeaders2(),
    };
    try {
      const response = await Axios(request);
      if ([401, 403].includes(response?.data?.statusCode)) {
        const response = await handleTokenRefresh(request);
        onSuccess && onSuccess(response.data);
        return response;
      } else {
        onSuccess && onSuccess(response.data);
        return response;
      }
    } catch (error) {
      if (error?.response && [401, 403].includes(error?.response?.status)) {
        try {
          const response = await handleTokenRefresh(request);
          onSuccess && onSuccess(response.data);
          return response;
        } catch (error) {
          onFailure && onFailure(error);
          return error;
        }
      } else {
        onFailure && onFailure(error);
        return error;
      }
    }
  }
);

export const reqToGetAddressFromLatLong = createAsyncThunk(
  apiEndpoints.getLocation,
  async ({ data, onSuccess, onFailure }) => {
    const request = {
      method: "POST",
      url: apiEndpoints.getLocation,
      data,
      headers: authHeaders2(),
    };
    try {
      const response = await Axios(request);
      onSuccess && onSuccess(response);
      return response;
    } catch (error) {
      if (error?.response && [401, 403].includes(error?.response?.status)) {
        try {
          const response = await handleTokenRefresh(request);
          onSuccess && onSuccess(response.data);
          return response;
        } catch (error) {
          onFailure && onFailure(error);
          return error;
        }
      } else {
        onFailure && onFailure(error);
        return error;
      }
    }
  }
);

export const reqToGetRestaurantDetails = createAsyncThunk(
  apiEndpoints.restaurantDetails,
  async ({ onSuccess, onFailure }) => {
    const request = {
      method: "GET",
      url: apiEndpoints.restaurantDetails,
      headers: authHeaders2(),
    };

    try {
      const response = await Axios(request);
      onSuccess && onSuccess(response);
      return response;
    } catch (error) {
      if (error?.response && [401, 403].includes(error?.response?.status)) {
        try {
          const response = await handleTokenRefresh(request);
          onSuccess && onSuccess(response);
          return response;
        } catch (error) {
          onFailure && onFailure(error);
          return error;
        }
      } else {
        onFailure && onFailure(error);
        return error;
      }
    }
  }
);

export const reqToGetRestaurantReports = createAsyncThunk(
  `${apiEndpoints.restaurantReports}/reports`,
  async ({ onSuccess, onFailure }) => {
    const request = {
      method: "GET",
      url: apiEndpoints.restaurantReports,
      headers: authHeaders2(),
    };
    try {
      const response = await Axios(request);
      onSuccess && onSuccess(response);
      return response;
    } catch (error) {
      if (error?.response && [401, 403].includes(error?.response?.status)) {
        try {
          const response = await handleTokenRefresh(request);
          onSuccess && onSuccess(response);
          return response;
        } catch (error) {
          onFailure && onFailure(error);
          return error;
        }
      } else {
        onFailure && onFailure(error);
        return error;
      }
    }
  }
);

export const reqToSubmitRestaurantDetails = createAsyncThunk(
  apiEndpoints.submitRestaurantDetails,
  async ({ data, onSuccess, onFailure }) => {
    const request = {
      method: "POST",
      url: apiEndpoints.submitRestaurantDetails,
      data,
      headers: authHeaders2(),
    };
    try {
      const response = await Axios(request);
      onSuccess && onSuccess(response);
      return response;
    } catch (error) {
      if (error?.response && [401, 403].includes(error?.response?.status)) {
        try {
          const response = await handleTokenRefresh(request);
          onSuccess && onSuccess(response);
          return response;
        } catch (error) {
          onFailure && onFailure(error);
          return error;
        }
      } else {
        onFailure && onFailure(error);
        return error;
      }
    }
  }
);

export const reqToSubmitTaskSummaryNotes = createAsyncThunk(
  apiEndpoints.addRestaurantTaskNotes,
  async ({ data, onSuccess, onFailure }) => {
    const request = {
      method: "POST",
      url: apiEndpoints.addRestaurantTaskNotes,
      data,
      headers: authHeaders2(),
    };
    try {
      const response = await Axios(request);
      onSuccess && onSuccess(response);
      return response;
    } catch (error) {
      if (error?.response && [401, 403].includes(error?.response?.status)) {
        try {
          const response = await handleTokenRefresh(request);
          onSuccess && onSuccess(response);
          return response;
        } catch (error) {
          onFailure && onFailure(error);
          return error;
        }
      } else {
        onFailure && onFailure(error);
        return error;
      }
    }
  }
);

const initialState = {
  loader: false,
  error: "",
  apiMessage: "",
  commonMessage: "",
  syncLoader: false,
  fetchLoader: false,
  scriptLoader: false,
  logoutLoader: false,
  initialSyncLoader: false,
};

const offlineSlice = createSlice({
  name: "offline",
  initialState,
  reducers: {
    reqToResetApiMessage: (state, action) => {
      state.apiMessage = action.payload;
    },
    reqToUpdateApiMessage: (state, action) => {
      state.commonMessage = action.payload;
    },
    reqToFetchDataProcess: (state, action) => {
      state.fetchLoader = action.payload;
    },
    reqToStartSyncProcess: (state, action) => {
      state.syncLoader = action.payload;
    },
    reqToInitialSyncProcess: (state, action) => {
      state.initialSyncLoader = action.payload;
    },
    reqToAutoScriptProcess: (state, action) => {
      state.scriptLoader = action.payload;
    },
    reqToUserLogoutProcess: (state, action) => {
      state.logoutLoader = action.payload;
    },
  },
  extraReducers: (builder) => {
    // UPLOAD MEDIA FILES
    builder
      .addCase(reqToUploadMediaFile.pending, () => {})
      .addCase(reqToUploadMediaFile.fulfilled, () => {})
      .addCase(reqToUploadMediaFile.rejected, () => {});

    // GET LOCATION
    builder
      .addCase(reqToGetAddressFromLatLong.pending, () => {})
      .addCase(reqToGetAddressFromLatLong.fulfilled, () => {})
      .addCase(reqToGetAddressFromLatLong.rejected, () => {});

    // GET RESTAURANT DETAILS
    builder
      .addCase(reqToGetRestaurantDetails.pending, () => {})
      .addCase(reqToGetRestaurantDetails.fulfilled, () => {})
      .addCase(reqToGetRestaurantDetails.rejected, () => {});

    // GET RESTAURANT REPORTS
    builder
      .addCase(reqToGetRestaurantReports.pending, () => {})
      .addCase(reqToGetRestaurantReports.fulfilled, () => {})
      .addCase(reqToGetRestaurantReports.rejected, () => {});

    // SUBMIT RESTAURANT DETAILS
    builder
      .addCase(reqToSubmitRestaurantDetails.pending, () => {})
      .addCase(reqToSubmitRestaurantDetails.fulfilled, () => {})
      .addCase(reqToSubmitRestaurantDetails.rejected, () => {});

    // SUMMIT TASK SUMMARY NOTES
    builder
      .addCase(reqToSubmitTaskSummaryNotes.pending, () => {})
      .addCase(reqToSubmitTaskSummaryNotes.fulfilled, () => {})
      .addCase(reqToSubmitTaskSummaryNotes.rejected, () => {});
  },
});

export const {
  reqToResetApiMessage,
  reqToUpdateApiMessage,
  reqToFetchDataProcess,
  reqToStartSyncProcess,
  reqToAutoScriptProcess,
  reqToUserLogoutProcess,
  reqToInitialSyncProcess,
} = offlineSlice.actions;
export default offlineSlice.reducer;
